import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../context/UserContext"; // Import UserContext
import axios from "axios";
import SignIn from "./SignIn"; // Import SignIn component
import Popup1 from "../components/Popup1"; // Import Popup1 component
import { useLocation, useNavigate } from "react-router-dom"; // Import for URL parameters
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Add this import
import TermsAndConditionsPDF from './PDFs/UrVote_Terms_and_Conditions.pdf';

const SignUpForm = ({ onClose, showModal, onSignInClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showRegModal, setShowRegModal] = useState(showModal || false);
  const { setEmailId, setIsLoggedIn, setParty } = useContext(UserContext); // Use context to update global state

  // State for invitation parameters
  const [invitationParams, setInvitationParams] = useState({
    email: null,
    party: null,
    candidate_state: null,
    token: null,
    isValid: false,
    loading: true,
    error: null,
  });

  const [formValues, setFormValues] = useState({
    givenName: "",
    surname: "",
    phoneNo: "",
    dob: "",
    streetAddress: "",
    emailId: "",
    password: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false); // State to toggle SignIn form
  const [suggestions, setSuggestions] = useState([]); // Store address suggestions
  const [loading, setLoading] = useState(false); // Address suggestions loading state
  const [query, setQuery] = useState(""); // Store user input

  const [suburb, setSuburb] = useState("");
  const [postcode, setPostcode] = useState("");
  const [state, setState] = useState("");
  const [showUserPreference, setShowUserPreference] = useState(false); // State to manage popup visibility

  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  // Add a new state to store the verified email
  const [verifiedEmail, setVerifiedEmail] = useState("");

  // Add new state for active tab
  const [activeTab, setActiveTab] = useState("individual");

  // Add new states for account type selection
  const [showAccountType, setShowAccountType] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [abn, setAbn] = useState("");
  const [showAbnInput, setShowAbnInput] = useState(false);
  const [abnError, setAbnError] = useState("");

  // Add formPage state
  const [formPage, setFormPage] = useState(1);

  // Add new states for charity verification
  const [isVerifyingCharity, setIsVerifyingCharity] = useState(false);
  const [charityVerified, setCharityVerified] = useState(false);
  const [charityError, setCharityError] = useState("");

  // Add a new state to store the verified email
  const [verifiedCharity, setVerifiedCharity] = useState("");

  // Add new state for active tab
  const [activeTabCharity, setActiveTabCharity] = useState("charity");

  // Add new states for account type selection
  const [showAccountTypeCharity, setShowAccountTypeCharity] = useState(true);
  const [selectedTypeCharity, setSelectedTypeCharity] = useState("");
  const [abnCharity, setAbnCharity] = useState("");
  const [showAbnInputCharity, setShowAbnInputCharity] = useState(false);
  const [abnErrorCharity, setAbnErrorCharity] = useState("");

  // Add formPage state
  const [formPageCharity, setFormPageCharity] = useState(1);

  // Add state for storing verified organization details
  const [verifiedOrgDetails, setVerifiedOrgDetails] = useState(null);

  // Add new state for verification message
  const [verificationMessage, setVerificationMessage] = useState("");
  const [showVerificationMessage, setShowVerificationMessage] = useState(false);

  // Add separate business verification states
  const [isVerifyingBusiness, setIsVerifyingBusiness] = useState(false);
  const [businessVerified, setBusinessVerified] = useState(false);
  const [businessError, setBusinessError] = useState("");
  const [showBusinessVerification, setShowBusinessVerification] =
    useState(false);

  // Add state for verified charity details
  const [verifiedCharityDetails, setVerifiedCharityDetails] = useState(null);
  
  // Add state for verification message display
  const [isVerifying, setIsVerifying] = useState(false);
  
  // Add state for terms and conditions
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  // Add new state variables for LGA and electorate
  const [lga, setLga] = useState("");
  const [electorate, setElectorate] = useState("");
  const [addressInfo, setAddressInfo] = useState(null);

  // Add this state to track if all password conditions are met
  const [allPasswordConditionsMet, setAllPasswordConditionsMet] = useState(false);

  // Add this state to track if we should show the tooltip
  const [showPasswordTooltip, setShowPasswordTooltip] = useState(false);

  // Determine if component is rendered as a standalone page
  const isStandalonePage = !onClose;

  // Update showRegModal when showModal prop changes
  useEffect(() => {
    if (showModal !== undefined) {
      setShowRegModal(showModal);
    }
  }, [showModal]);

  // Auto-open the registration modal when rendered as a standalone page
  useEffect(() => {
    if (isStandalonePage) {
      setShowRegModal(true);
    }
  }, [isStandalonePage]);

  // Parse URL parameters for invitation
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    const party = params.get("party");
    const candidate_state = params.get("candidate_state");
    const token = params.get("token");
    const first_name = params.get("first_name");
    const last_name = params.get("last_name");

    if (email && party && token) {
      console.log("Found invitation parameters:", {
        email,
        party,
        candidate_state,
        token,
        first_name,
        last_name
      });
      
      // Set invitation parameters
      setInvitationParams({
        email,
        party,
        candidate_state: candidate_state || "Federal",
        token,
        isValid: false,
        loading: true,
        error: null,
      });

      // Update form values with email and names
      setFormValues((prev) => ({
        ...prev,
        emailId: email,
        givenName: decodeURIComponent(first_name || ""),
        surname: decodeURIComponent(last_name || "")
      }));

      // Verify the invitation token
      verifyInvitationToken(email, party, candidate_state, token);
      
      // Auto-open the registration modal when invitation parameters are present
      setShowRegModal(true);

      // Skip account type selection for invited users
      setFormPage(2);
    }
  }, [location]);

  // Function to verify invitation token
  const verifyInvitationToken = async (
    email,
    party,
    candidate_state,
    token
  ) => {
    try {
      console.log("Verifying invitation token:", {
        email,
        party,
        candidate_state,
        token,
      });
      const response = await fetch(
        "/api/verify-invitation",
        {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, party, candidate_state, token }),
        }
      );

      if (response.ok) {
        // Token is valid
        console.log("Invitation token verified successfully");
        setInvitationParams((prev) => ({
          ...prev,
          isValid: true,
          loading: false,
          error: null,
        }));
        
        // Auto-verify email for invited candidates
        setIsEmailVerified(true);
        setVerifiedEmail(email);
      } else {
        // Token is invalid
        const errorData = await response.json();
        console.error("Invalid invitation token:", errorData);
        setInvitationParams((prev) => ({
          ...prev,
          isValid: false,
          loading: false,
          error: errorData.error || "Invalid invitation",
        }));
        
        // Clear URL parameters if not a standalone page
        //todo: remove this, not for normal users
        if (!isStandalonePage) {
          navigate("/signup", { replace: true });
        }
      }
    } catch (error) {
      console.error("Error verifying invitation token:", error);
      setInvitationParams((prev) => ({
        ...prev,
        isValid: false,
        loading: false,
        error: "Error verifying invitation",
      }));
    }
  };

  // Add validateAbn function
  const validateAbn = (abn) => {
    return /^\d{11}$/.test(abn);
  };

  const toggleRegModal = () => {
    setShowRegModal(!showRegModal);
    setFormErrors({});
    if (!showRegModal) {
      setFormValues({
        givenName: "",
        surname: "",
        dob: "",
        streetAddress: "",
        emailId: "",
        password: "",
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Prevent changing email if it's from invitation
    if (name === "emailId" && invitationParams.email) {
      return;
    }

    // Add ABN number validation
    if (activeTab === "organisation" && name === "surname") {
      // Only allow numbers for ABN
      if (!/^\d*$/.test(value)) {
        return;
      }
    }

    if (name === "emailId" && isEmailVerified && value !== verifiedEmail) {
      setIsEmailVerified(false);
      setOtpSent(false);
      setOtp("");
      setVerifiedEmail("");
      alert("Email changed. You'll need to verify the new email address.");
    }
    
    setFormValues({
      ...formValues,
      [name]: value,
    });

    // If this is a password change, check all conditions
    if (name === 'password') {
      const validations = {
        length: value.length >= 8,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        specialChar: /[@$!%*?&]/.test(value)
      };
      setPasswordValidation(validations);

      // Check if all conditions are met
      const areAllConditionsMet = Object.values(validations).every(condition => condition === true);
      setAllPasswordConditionsMet(areAllConditionsMet);
      
      // Show tooltip when typing password
      setShowPasswordTooltip(true);
      
      // If all conditions are met, set a timer to hide the tooltip
      if (areAllConditionsMet) {
        setTimeout(() => {
          setShowPasswordTooltip(false);
        }, 1500); // Hide after 1.5 seconds
      }
    }    
    // Fetch address suggestions when user types in streetAddress
    if (name === "streetAddress" && value.length > 2) {
      fetchAddressSuggestions(value);
    }
  };

  const fetchAddressSuggestions = async (input) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "/api/address/autocomplete",
        {
          streetAddress: input,
        }
      );
      setSuggestions(response.data.suggestions || []);
    } catch (error) {
      console.error(
        "Error fetching address suggestions:",
        error.response?.data || error.message
      );
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSuggestion = async (suggestion) => {
    setFormValues((prev) => ({
      ...prev,
      streetAddress: suggestion.streetAddress,
    }));
    setSuburb(suggestion.suburb);
    setPostcode(suggestion.postCode);
    const stateMapping = {
      VIC: "Victoria",
      NSW: "New South Wales",
      QLD: "Queensland",
      SA: "South Australia",
      WA: "Western Australia",
      TAS: "Tasmania",
      NT: "Northern Territory",
      ACT: "Australian Capital Territory",
    };

    setState(stateMapping[suggestion.state] || suggestion.state);
    setSuggestions([]);

    // Fetch LGA and electorate information
    try {
      const response = await axios.post(
        "/api/address/info",
        {
          streetAddress: suggestion.streetAddress,
          suburb: suggestion.suburb,
          state: suggestion.state,
          postCode: suggestion.postCode
        }
      );
      
      if (response.data) {
        setLga(response.data.lga);
        setElectorate(response.data.electoralDivision);
        setAddressInfo(response.data);
      }
    } catch (error) {
      console.error("Error fetching address information:", error);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    let errors = {};
    // Updated name regex to be more inclusive
    // Allows letters, spaces, hyphens, apostrophes, and accented characters
    const nameRegex = /^[a-zA-ZÀ-ÿ]+([-' ][a-zA-ZÀ-ÿ]+)*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const abnRegex = /^\d{11}$/;

    if (activeTab === "organisation") {
      if (!formValues.givenName) {
        errors.givenName = "Organisation Name is required";
      }
      if (!formValues.surname || !abnRegex.test(formValues.surname)) {
        errors.surname = "ABN must be 11 digits";
      }
    } else {
      // Handle individual name validation
      const trimmedGivenName = formValues.givenName.trim();
      const trimmedSurname = formValues.surname.trim();

      if (!trimmedGivenName) {
        errors.givenName = "Given Name is required";
      } else if (!nameRegex.test(trimmedGivenName)) {
        errors.givenName = "Given Name can only contain letters, hyphens, apostrophes and spaces";
      }

      if (!trimmedSurname) {
        errors.surname = "Surname is required";
      } else if (!nameRegex.test(trimmedSurname)) {
        errors.surname = "Surname can only contain letters, hyphens, apostrophes and spaces";
      }
    }

    if (!formValues.dob) {
      errors.dob = "Date of Birth is required";
    }
    if (!formValues.streetAddress) {
      errors.streetAddress = "Address is required";
    }
    if (!formValues.emailId || !emailRegex.test(formValues.emailId)) {
      errors.emailId = "Invalid Email Address";
    }
    if (!formValues.password || !passwordRegex.test(formValues.password)) {
      errors.password = "Password must contain at least 8 characters, one uppercase, one lowercase, one number, and one special character";
    }
    if (!agreedToTerms) {
      errors.terms = "You must agree to the Terms and Conditions";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSendOTP = async () => {
    if (!formValues.emailId || !validateEmail(formValues.emailId)) {
      setFormErrors({
        ...formErrors,
        emailId: "Please enter a valid email address",
      });
      return;
    }

    try {
      const response = await fetch("/api/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formValues.emailId }),
      });

      if (response.ok) {
        setOtpSent(true);
        setResendDisabled(true);
        setResendTimer(30); // Start 30 second timer
        const timer = setInterval(() => {
          setResendTimer((prev) => {
            if (prev <= 1) {
              clearInterval(timer);
              setResendDisabled(false);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
        alert("OTP has been sent to your email address");
      } else {
        const error = await response.text();
        alert(`Failed to send OTP: ${error}`);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };

  const handleResendOTP = async () => {
    if (resendDisabled) return;
    await handleSendOTP();
  };

  const handleVerifyOTP = async () => {
    try {
      const response = await fetch("/api/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          email: formValues.emailId,
          otp: otp,
        }),
      });

      if (response.ok) {
        setIsEmailVerified(true);
        setVerifiedEmail(formValues.emailId); // Store the verified email
        setOtpError("");
        alert("Email verified successfully!");
      } else {
        setOtpError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("Failed to verify OTP. Please try again.");
    }
  };

  // Update type selection handler
  const handleTypeSelect = (type) => {
    if (type === "individual") {
      setSelectedType("individual");
      setFormPage(2);
    } else {
      setSelectedType(type);
      setShowAbnInput(true);
    }
  };

  // Update handleAbnSubmit to show verification message
  const handleAbnSubmit = async () => {
    if (!validateAbn(abn)) {
      setAbnError("Please enter a valid 11-digit ABN");
      return;
    }

    setIsVerifying(true);
    setVerificationMessage("");

    let isVerified = false;
    if (selectedType === "charity") {
      try {
        isVerified = await verifyCharityABN(abn);
        if (!isVerified) {
          setIsVerifying(false);
          return;
        }
        
        // On successful verification
        setVerificationMessage("✓ ABN Verified Successfully");
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        setIsVerifying(false);
        if (isVerified) {
          setActiveTab("organisation");
          setFormPage(2);
        }
      } catch (error) {
        console.error("Error during charity verification:", error);
        setIsVerifying(false);
        return;
      }
    } else if (selectedType === "business") {
      try {
        isVerified = await verifyBusinessABN(abn);
        if (!isVerified) {
          setIsVerifying(false);
          return;
        }
        
        // On successful verification
        setVerificationMessage("✓ ABN Verified Successfully");
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        setIsVerifying(false);
        if (isVerified) {
          setActiveTab("organisation");
          setFormPage(2);
        }
      } catch (error) {
        console.error("Error during business verification:", error);
        setIsVerifying(false);
        return;
      }
    }
  };

  const verifyCharityABN = async (abn) => {
    try {
      const response = await fetch('/api/verify-charity', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ abn })
      });

      const data = await response.json();
      
      if (response.ok) {
        if (data.verified) {
          setFormValues(prev => ({
            ...prev,
            givenName: data.organizationName,
            surname: data.abn
          }));
          return true;
        } else {
          setCharityError('Entered ABN Number is wrong. Please check your ABN number.');
          setVerificationMessage('Entered ABN Number is wrong. Please check your ABN number.');
          return false;
        }
      } else {
        throw new Error('Entered ABN Number is wrong. Please check your ABN number.');
      }
    } catch (error) {
      console.error("Charity verification error:", error);
      setCharityError('Entered ABN Number is wrong. Please check your ABN number.');
      setVerificationMessage('Entered ABN Number is wrong. Please check your ABN number.');
      return false;
    }
  };

  const verifyBusinessABN = async (abn) => {
    try {
      const response = await fetch('/api/verify-business', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ abn })
      });

      const data = await response.json();
      
      if (response.ok) {
        if (data.verified) {
          setFormValues(prev => ({
            ...prev,
            givenName: data.organizationName,
            surname: data.abn
          }));
          return true;
        } else {
          setCharityError('Entered ABN Number is wrong. Please check your ABN number.');
          setVerificationMessage('Entered ABN Number is wrong. Please check your ABN number.');
          return false;
        }
      } else {
        throw new Error('Entered ABN Number is wrong. Please check your ABN number.');
      }
    } catch (error) {
      console.error("Business verification error:", error);
      setCharityError('Entered ABN Number is wrong. Please check your ABN number.');
      setVerificationMessage('Entered ABN Number is wrong. Please check your ABN number.');
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      try {
        const requestBody = {
          firstName: formValues.givenName,
          lastName: activeTab === "organisation" ? null : formValues.surname, // Set to null for organisation
          emailId: formValues.emailId,
          dob: formValues.dob,
          streetAddress: formValues.streetAddress,
          postcode: postcode,
          state: state,
          password: formValues.password,
          suburb: suburb,
          // Add ABN field for organisation
          abn: activeTab === "organisation" ? formValues.surname : null, // Use surname field value as ABN
          isOrganisation: activeTab === "organisation", // Add flag to identify organisation
        };
        
        // Add invitation parameters if present
        if (invitationParams.isValid) {
          requestBody.party = invitationParams.party;
          requestBody.candidate_state = invitationParams.candidate_state;
          requestBody.token = invitationParams.token;
        }

        const response = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (response.ok) {
          alert("Congratulations for taking Quiz!");
          
          const loginResponse = await fetch(
            "/api/signin",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                emailId: formValues.emailId,
                password: formValues.password,
              }),
            }
          );

          if (loginResponse.ok) {
            const loginData = await loginResponse.json();
            
            window.location.href = "/main";
            // Store token in localStorage
            if (loginData.token) {
              localStorage.setItem("token", loginData.token);
              localStorage.setItem("emailId", formValues.emailId);
              localStorage.setItem("firstName", formValues.givenName);
            }
            
            setEmailId(formValues.emailId);
            setIsLoggedIn(true);
            
            // Set party information in UserContext if this is a candidate
            if (invitationParams.isValid && invitationParams.party) {
              setParty(invitationParams.party);
            }
            
            // Close the modal and show user preferences
            setShowUserPreference(true);
            setShowRegModal(false); // Use this instead of toggleRegModal
            if (onClose) onClose(); // Only call onClose if it exists
          } else {
            alert("Auto-login failed. Please sign in manually.");
            setShowRegModal(false); // Close the modal even if login fails
          }
        } else {
          const message = await response.text();
          alert(`Failed to register: ${message}`);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("An error occurred during registration");
      }
    }
  };

  // Update the renderFormLabel function with bolder text
  const renderFormLabel = (label) => (
    <div
      style={{
        width: "150px",
        marginRight: "10px",
        textAlign: "left", // Keep text left-aligned
        display: "flex",
        alignItems: "center",
        gap: "2px" // Small gap between label and asterisk
      }}
    >
      <span style={{ 
        fontWeight: "700" // Increased from 600 to 700 for bolder text
      }}>
        {label}
      </span>
      <span style={{ 
        color: "red",
        marginLeft: "2px" // Small space between label and asterisk
      }}>
        *
      </span>
    </div>
  );

  const renderEmailField = () => (
    <div className="mb-4">
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor="emailId"
      >
        Email Address <span className="text-red-500">*</span>
      </label>
      <input
        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
          formErrors.emailId ? "border-red-500" : ""
        }`}
        id="emailId"
        type="email"
        placeholder="Email Address"
        name="emailId"
        value={formValues.emailId}
        onChange={handleInputChange}
        disabled={invitationParams.email !== null} // Disable if from invitation
        required
      />
      {formErrors.emailId && (
        <p className="text-red-500 text-xs italic">{formErrors.emailId}</p>
      )}
      
      {/* Show party and electoral state information if from invitation */}
      {invitationParams.isValid && (
        <div className="mt-2 p-2 bg-blue-50 text-blue-700 rounded">
          <p>
            You are registering as a candidate for{" "}
            <strong>{invitationParams.party}</strong> in{" "}
            <strong>{invitationParams.candidate_state || "Federal"}</strong>
          </p>
        </div>
      )}
      
      {/* Show error if invitation is invalid */}
      {invitationParams.error && (
        <div className="mt-2 p-2 bg-red-50 text-red-700 rounded">
          <p>{invitationParams.error}</p>
        </div>
      )}
      
      {/* Email verification section - hide for invited candidates */}
      {!invitationParams.isValid && (
        <div className="mt-2">
          {!isEmailVerified ? (
            <div className="flex items-center">
              <button
                type="button"
                onClick={handleSendOTP}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline text-sm"
                disabled={!formValues.emailId || otpSent}
              >
                {otpSent ? "OTP Sent" : "Verify Email"}
              </button>
              {otpSent && (
                <div className="ml-2 flex items-center">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="shadow appearance-none border rounded py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                  />
                  <button
                    type="button"
                    onClick={handleVerifyOTP}
                    className="ml-2 bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline text-sm"
                  >
                    Verify
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="text-green-500 text-sm">Email verified ✓</div>
          )}
          {otpError && (
            <p className="text-red-500 text-xs italic">{otpError}</p>
          )}
        </div>
      )}
    </div>
  );

  // Add business verification modal
  const BusinessVerificationModal = () => (
    <div className="modal">
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "10px",
          width: '400px',
          position: "relative",
          textAlign: "center"
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>Business ABN Verification</h2>
        <p>{verificationMessage}</p>
        {isVerifyingBusiness && (
          <div style={{ marginTop: "20px" }}>
            <div className="spinner" style={{
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #3498db",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              animation: "spin 1s linear infinite",
              margin: "0 auto"
            }} />
          </div>
        )}
        {businessError && (
          <div style={{ color: 'red', marginTop: '10px' }}>{businessError}</div>
        )}
      </div>
    </div>
  );

  // Add charity verification modal
  const CharityVerificationModal = () => (
    <div className="modal">
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "10px",
          width: '400px',
          position: "relative",
          textAlign: "center"
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>Charity ABN Verification</h2>
        <p>{verificationMessage}</p>
        {isVerifyingCharity && (
          <div style={{ marginTop: "20px" }}>
            <div className="spinner" style={{
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #3498db",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              animation: "spin 1s linear infinite",
              margin: "0 auto"
            }} />
          </div>
        )}
        {charityError && (
          <div style={{ color: 'red', marginTop: '10px' }}>{charityError}</div>
        )}
      </div>
    </div>
  );

  // Add verification message display component
  const VerificationMessage = () => (
    isVerifying && (
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '5px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <p>{verificationMessage}</p>
      </div>
    )
  );

  // Modified close handler to handle both popup and standalone modes
  const handleClose = () => {
    setShowRegModal(false); // Always set showRegModal to false when closing
    if (isStandalonePage) {
      // If standalone page, navigate back to home
      navigate("/");
    } else if (onClose) {
      // If popup, call the provided onClose function
      onClose();
    }
  };

  // Add CSS for spinner
  const spinnerStyle = {
    width: '16px',
    height: '16px',
    border: '2px solid #ffffff',
    borderTop: '2px solid transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginRight: '8px',
    display: 'inline-block'
  };

  // Add new function to format names
  const formatName = (name) => {
    // Remove multiple spaces and trim
    let formatted = name.replace(/\s+/g, ' ').trim();
    // Capitalize each word
    formatted = formatted.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    return formatted;
  };

  // Add new function to handle blur event (when field loses focus)
  const handleBlur = (e) => {
    const { name, value } = e.target;
    
    // Only format names for individual accounts
    if (activeTab === "individual" && (name === "givenName" || name === "surname")) {
      const formattedValue = formatName(value);
      setFormValues(prev => ({
        ...prev,
        [name]: formattedValue
      }));
    }
  };

  // Update the passwordTooltipStyle
  const passwordTooltipStyle = {
    position: 'absolute',
    left: '0',
    top: '100%', // Position below the password field
    marginTop: '10px', // Add some space between field and tooltip
    backgroundColor: '#2c2c2c',
    color: 'white',
    padding: '15px',
    borderRadius: '8px',
    fontSize: '12px',
    zIndex: 1001, // Ensure it's above other elements
    width: '100%', // Match parent width
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    // Add speech bubble triangle pointing up
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '20px',
      top: '-8px',
      width: '0',
      height: '0',
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: '8px solid #2c2c2c'
    }
  };

  return (
    <>
      {showUserPreference ? (
        <Popup1 onClose={() => setShowUserPreference(false)} />
      ) : showBusinessVerification && selectedType === 'business' ? (
        <BusinessVerificationModal />
      ) : showVerificationMessage && selectedType === 'charity' ? (
        <CharityVerificationModal />
      ) : showSignIn ? (
        <SignIn onClose={() => setShowSignIn(false)} />
      ) : (
        <div
          className="modal"
          style={{
            position: isStandalonePage ? "relative" : "fixed",
            top: isStandalonePage ? "auto" : 0,
            left: isStandalonePage ? "auto" : 0,
            right: isStandalonePage ? "auto" : 0,
            bottom: isStandalonePage ? "auto" : 0,
            backgroundColor: isStandalonePage
              ? "transparent"
              : "rgba(0,0,0,0.5)",
            // ... existing code ...
            display: showRegModal || isStandalonePage ? "flex" : "none",
            alignItems: "center",
            justifyContent: "center",
            padding: isStandalonePage ? "40px 0" : 0,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              width: formPage === 1 ? "400px" : "500px",
              position: "relative",
              maxHeight: "90vh", // Limit height to make it scrollable
              overflowY: "auto", // Enable vertical scrolling
              margin: isStandalonePage ? "0 auto" : 0,
              boxShadow: isStandalonePage
                ? "0 4px 8px rgba(0,0,0,0.1)"
                : "none",
            }}
          >
            {!isStandalonePage && (
              <button
                onClick={handleClose}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            )}

            {/* Check if we have invitation parameters - if so, skip account type selection */}
            {formPage === 1 && !invitationParams.isValid ? (
              // Page 1 - Account Type Selection
              <>
                <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
                  Account Type
                </h2>

                {!showAbnInput ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    {["individual", "business", "charity"].map((type) => (
                      <button
                        key={type}
                        onClick={() => handleTypeSelect(type)}
                        style={{
                          padding: "15px",
                          fontSize: "16px",
                          cursor: "pointer",
                          backgroundColor: "#007bff",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          textTransform: "capitalize",
                        }}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <input
                      type="text"
                      id="abn-input"
                      placeholder="Enter ABN (11 digits)"
                      value={abn}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        if (value.length <= 11) setAbn(value);
                      }}
                      style={{
                        padding: '10px',
                        fontSize: '16px',
                        borderRadius: '5px',
                        border: '1px solid #ccc'
                      }}
                    />
                    {abnError && (
                      <div style={{ 
                        color: "#FF0000", // Bright red color
                        fontSize: "14px",
                        textAlign: "center",
                        fontWeight: "500" // Slightly bold
                      }}>
                        {abnError}
                      </div>
                    )}
                    {verificationMessage && (
                      <div style={{ 
                        color: verificationMessage.includes('wrong') ? "#FF0000" : "green", 
                        fontSize: "14px", 
                        textAlign: "center",
                        marginBottom: "10px",
                        fontWeight: "500"
                      }}>
                        {verificationMessage}
                      </div>
                    )}
                    <button
                      onClick={handleAbnSubmit}
                      disabled={isVerifying}
                      style={{
                        padding: '10px',
                        fontSize: '16px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: isVerifying ? 'wait' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {isVerifying && (
                        <span style={spinnerStyle}></span>
                      )}
                      {isVerifying ? 'Verifying...' : 'Continue'}
                    </button>
                  </div>
                )}

                {/* Add Sign In link */}
                <div style={{ textAlign: "center", marginTop: "15px" }}>
                  Already have an account?{" "}
                  <button
                    onClick={() => {
                      if (onSignInClick) {
                        onSignInClick();
                      }
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#007bff",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Sign In
                  </button>
                </div>
              </>
            ) : (
              // Page 2 - Registration Form
              <>
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              SIGN UP
            </h2>

            <form onSubmit={handleSubmit}>
                  {activeTab === "individual" || invitationParams.isValid ? (
                    // Individual form fields (also used for invited candidates)
                    <>
              {[
                {
                  label: "Given Name",
                  name: "givenName",
                  placeholder: "Given Name",
                  required: true
                },
                {
                  label: "Surname",
                  name: "surname",
                  placeholder: "Surname",
                  required: true
                },
                {
                  label: "Date of Birth",
                  name: "dob",
                  placeholder: "dd/mm/yyyy",
                  type: "text",
                  required: true,
                  render: () => (
                    <div style={{ display: "flex", width: "100%" }}>
                      <input
                        type="date"
                        onChange={(e) => {
                          const date = new Date(e.target.value);
                          const formattedDate = date.toLocaleDateString('en-GB');
                          handleInputChange({
                            target: {
                              name: 'dob',
                              value: formattedDate
                            }
                          });
                        }}
                        style={{
                          padding: "8px",
                          borderRadius: "5px",
                          border: `1px solid ${formErrors.dob ? "red" : "#ccc"}`,
                          width: "100%",
                          boxSizing: "border-box"
                        }}
                      />
                    </div>
                  )
                },
                {
                  label: "Email",
                  name: "emailId",
                  placeholder: "Email",
                  type: "email",
                  required: true,
                  customInput: invitationParams.isValid ? (
                    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                      <input
                        type="email"
                        name="emailId"
                        id="emailId"
                        value={formValues.emailId}
                        onChange={handleInputChange}
                        placeholder="Email"
                        disabled={invitationParams.email !== null}
                        style={{
                          flex: 1,
                          padding: "8px",
                          borderRadius: "5px",
                          border: `1px solid ${formErrors.emailId ? "red" : "#ccc"}`,
                          width: "100%",
                          boxSizing: "border-box"
                        }}
                      />
                      
                      {/* Show party and electoral state information */}
                      <div style={{ 
                        marginTop: "10px", 
                        padding: "10px", 
                        backgroundColor: "#f0f7ff", 
                        color: "#0056b3",
                        borderRadius: "5px" 
                      }}>
                        <p>You are registering as a candidate for <strong>{invitationParams.party}</strong> in <strong>{invitationParams.candidate_state || 'Federal'}</strong></p>
                      </div>
                      
                      {/* Show error if invitation is invalid */}
                      {invitationParams.error && (
                        <div style={{ 
                          marginTop: "10px", 
                          padding: "10px", 
                          backgroundColor: "#fff0f0", 
                          color: "#d32f2f",
                          borderRadius: "5px" 
                        }}>
                          <p>{invitationParams.error}</p>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                      <div className="email-verification-container" style={{ 
                        display: "flex", 
                        gap: "10px",
                        flexDirection: "row", // Default for desktop
                      }}>
                        <input
                          type="email"
                          name="emailId"
                          id="emailId"
                          value={formValues.emailId}
                          onChange={handleInputChange}
                          placeholder="Email"
                          style={{
                            flex: 1,
                            padding: "8px",
                            borderRadius: "5px",
                            border: `1px solid ${formErrors.emailId ? "red" : "#ccc"}`,
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                        <button
                          type="button"
                          onClick={otpSent ? handleResendOTP : handleSendOTP}
                          disabled={(!formValues.emailId) || (resendDisabled && otpSent)}
                          className="verify-email-button"
                          style={{
                            padding: "8px 15px",
                            backgroundColor: (!formValues.emailId) || (resendDisabled && otpSent) ? "#ccc" : "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: (!formValues.emailId) || (resendDisabled && otpSent) ? "default" : "pointer",
                            whiteSpace: "nowrap",
                            minWidth: "120px",
                          }}
                        >
                          {otpSent ? (resendDisabled ? `Wait ${resendTimer}s` : "Resend OTP") : "Verify Email"}
                        </button>
                      </div>

                      {/* OTP Verification Section */}
                      {otpSent && !isEmailVerified && (
                        <div style={{ marginTop: "10px" }}>
                          <div
                            style={{
                              width: "150px",
                              marginRight: "0px",
                            }}
                          >
                            Enter OTP
                          </div>
                          <div
                            className="otp-verification-container"
                            style={{
                              display: "flex",
                              gap: "10px",
                              flex: 1,
                            }}
                          >
                            <input
                              type="text"
                              placeholder="Enter verification code"
                              value={otp}
                              onChange={(e) => setOtp(e.target.value)}
                              style={{
                                flex: 1,
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                              }}
                            />
                            <button
                              type="button"
                              onClick={handleVerifyOTP}
                              className="verify-otp-button"
                              style={{
                                padding: "8px 15px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                minWidth: "120px",
                              }}
                            >
                              Verify OTP
                            </button>
                          </div>
                        </div>
                      )}
                      {otpError && (
                        <div
                          role="alert"
                          style={{
                            color: "red",
                            marginTop: "5px",
                            marginLeft: "160px",
                          }}
                        >
                          {otpError}
                        </div>
                      )}
                      {isEmailVerified && !invitationParams.isValid && (
                        <div
                          role="status"
                          style={{
                            color: "green",
                            marginTop: "5px",
                            marginLeft: "160px",
                          }}
                        >
                          ✓ Email verified successfully
                        </div>
                      )}
                    </div>
                  )
                },
              ].map(
                ({
                  label,
                  name,
                  placeholder,
                  type = "text",
                  customInput,
                  render,
                  required
                }) => (
                <div
                  className="form-group"
                  style={{
                    marginBottom: "15px",
                    display: "flex",
                              flexDirection: "column",
                  }}
                  key={name}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "5px",
                                width: "100%",
                    }}
                  >
                    {renderFormLabel(label)}
                    <div style={{ flex: 1 }}>
                      {render ? render() : customInput || (
                        <input
                          type={type}
                          name={name}
                                    id={label.toLowerCase().replace(/\s+/g, '-')}
                          value={formValues[name]}
                          onChange={handleInputChange}
                          placeholder={placeholder}
                          style={{
                            width: "100%",
                            padding: "8px",
                            borderRadius: "5px",
                                      border: `1px solid ${
                                        formErrors[name] ? "red" : "#ccc"
                                      }`,
                                      boxSizing: "border-box",
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {formErrors[name] && (
                    <small
                      style={{
                        color: "red",
                        display: "block",
                                  marginLeft: "160px",
                      }}
                    >
                      {formErrors[name]}
                    </small>
                  )}
                </div>
                        )
                      )}
                    </>
                  ) : (
                    // Organisation form fields
                    <>
                      {[
                        {
                          label: "Organisation Name",
                          name: "givenName",
                          placeholder: "Organisation Name",
                          required: true
                        },
                        {
                          label: "ABN Number",
                          name: "surname",
                          value: abn,
                          disabled: true,
                          required: true
                        },
                        {
                          label: "Date of Birth",
                          name: "dob",
                          placeholder: "dd/mm/yyyy",
                          type: "text",
                          required: true,
                          render: () => (
                            <div style={{ display: "flex", width: "100%" }}>
                              <input
                                type="date"
                                onChange={(e) => {
                                  const date = new Date(e.target.value);
                                  const formattedDate = date.toLocaleDateString('en-GB');
                                  handleInputChange({
                                    target: {
                                      name: 'dob',
                                      value: formattedDate
                                    }
                                  });
                                }}
                                style={{
                                  padding: "8px",
                                  borderRadius: "5px",
                                  border: `1px solid ${formErrors.dob ? "red" : "#ccc"}`,
                                  width: "100%",
                                  boxSizing: "border-box"
                                }}
                              />
                            </div>
                          )
                        },
                        {
                          label: "Email",
                          name: "emailId",
                          placeholder: "Email",
                          type: "email",
                          required: true,
                          customInput: (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                              }}
                            >
                              <div style={{ display: "flex", gap: "10px" }}>
                                <input
                                  type="email"
                                  name="emailId"
                                  id="emailId"
                                  value={formValues.emailId}
                                  onChange={handleInputChange}
                                  placeholder="Email"
                                  style={{
                                    flex: 1,
                                    padding: "8px",
                                    borderRadius: "5px",
                                    border: `1px solid ${
                                      formErrors.emailId ? "red" : "#ccc"
                                    }`,
                                    width: "100%",
                                    boxSizing: "border-box",
                                  }}
                                />
                                <button
                                  type="button"
                                  onClick={otpSent ? handleResendOTP : handleSendOTP}
                                  disabled={(!formValues.emailId) || (resendDisabled && otpSent)}
                                  style={{
                                    padding: "8px 15px",
                                    backgroundColor: (!formValues.emailId) || (resendDisabled && otpSent) ? "#ccc" : "#007bff",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: (!formValues.emailId) || (resendDisabled && otpSent) ? "default" : "pointer",
                                    whiteSpace: "nowrap",
                                    minWidth: "120px",
                                  }}
                                >
                                  {otpSent ? (resendDisabled ? `Wait ${resendTimer}s` : "Resend OTP") : "Verify Email"}
                                </button>
                              </div>

                              {/* OTP Verification Section */}
                              {otpSent && !isEmailVerified && (
                                <div style={{ marginTop: "10px" }}>
                                  <div
                                    style={{
                                      width: "150px",
                                      marginRight: "0px",
                                    }}
                                  >
                                    Enter OTP
                                  </div>
                                  <div
                                    className="otp-verification-container"
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      flex: 1,
                                    }}
                                  >
                                    <input
                                      type="text"
                                      placeholder="Enter verification code"
                                      value={otp}
                                      onChange={(e) => setOtp(e.target.value)}
                                      style={{
                                        flex: 1,
                                        padding: "8px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                    <button
                                      type="button"
                                      onClick={handleVerifyOTP}
                                      className="verify-otp-button"
                                      style={{
                                        padding: "8px 15px",
                                        backgroundColor: "#28a745",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        minWidth: "120px",
                                      }}
                                    >
                                      Verify OTP
                                    </button>
                                  </div>
                                </div>
                              )}
                              {otpError && (
                                <div
                                  style={{
                                    color: "red",
                                    marginTop: "5px",
                                    marginLeft: "160px",
                                  }}
                                >
                                  {otpError}
                                </div>
                              )}
                              {isEmailVerified && (
                                <div
                                  style={{
                                    color: "green",
                                    marginTop: "5px",
                                    marginLeft: "160px",
                                  }}
                                >
                                  ✓ Email verified successfully
                                </div>
                              )}
                            </div>
                          ),
                        },
                      ].map(
                        ({
                          label,
                          name,
                          placeholder,
                          type = "text",
                          customInput,
                          required
                        }) => (
              <div
                className="form-group"
                style={{
                  marginBottom: "15px",
                  display: "flex",
                              flexDirection: "column",
                }}
                            key={name}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "5px",
                        width: "100%",
                  }}
                >
                  {renderFormLabel(label)}
                  <div style={{ flex: 1 }}>
                    {customInput || (
                      <input
                        type={type}
                        name={name}
                        id={label.toLowerCase().replace(/\s+/g, '-')}
                        value={formValues[name]}
                        onChange={handleInputChange}
                        placeholder={placeholder}
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "5px",
                          border: `1px solid ${
                            formErrors[name] ? "red" : "#ccc"
                          }`,
                          boxSizing: "border-box",
                        }}
                      />
                    )}
                  </div>
                </div>
                {formErrors[name] && (
                  <small
                    style={{
                      color: "red",
                      display: "block",
                      marginLeft: "160px",
                    }}
                  >
                    {formErrors[name]}
                  </small>
                )}
              </div>
                        )
                      )}
                    </>
                  )}

                  {/* Common fields for both individual and organization */}
                  <div
                    className="form-group"
                    style={{
                      marginBottom: "15px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "5px",
                        width: "100%",
                  }}
                >
                  {renderFormLabel("Address")}
                  <div style={{ flex: 1, position: "relative" }}>
                    <input
                      type="text"
                      name="streetAddress"
                      value={formValues.streetAddress}
                      onChange={handleInputChange}
                      placeholder="Address"
                      style={{
                        width: "100%",
                        padding: "8px",
                        borderRadius: "5px",
                            border: `1px solid ${
                              formErrors.streetAddress ? "red" : "#ccc"
                            }`,
                            boxSizing: "border-box",
                      }}
                    />
                    {loading && (
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              margin: "5px 0 0",
                            }}
                          >
                        Fetching suggestions...
                      </p>
                    )}
                    <ul
                      style={{
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                        maxHeight: "150px",
                        overflowY: "auto",
                            border:
                              suggestions.length > 0
                                ? "1px solid #ddd"
                                : "none",
                        backgroundColor: "#fff",
                        position: "absolute",
                        zIndex: 1000,
                        width: "100%",
                            boxShadow:
                              suggestions.length > 0
                                ? "0px 2px 5px rgba(0, 0, 0, 0.1)"
                                : "none",
                      }}
                    >
                      {suggestions.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => handleSelectSuggestion(item)}
                          style={{
                            cursor: "pointer",
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          {`${item.streetAddress}, ${item.suburb}, ${item.state}, ${item.postCode}`}
                        </li>
                      ))}
                    </ul>
                    {addressInfo && (
                      <div style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#f0f7ff",
                        borderRadius: "5px",
                        fontSize: "14px"
                      }}>
                        <p style={{ margin: "0 0 5px 0" }}>Your LGA is: <strong>{addressInfo.lga}</strong></p>
                        <p style={{ margin: "0" }}>Your electorate is: <strong>{addressInfo.electoralDivision}</strong></p>
                      </div>
                    )}
                  </div>
                </div>
                {formErrors.streetAddress && (
                      <small
                        style={{
                          color: "red",
                          display: "block",
                          marginLeft: "160px",
                        }}
                      >
                    {formErrors.streetAddress}
                  </small>
                )}
              </div>

              <div
                className="form-group"
                style={{
                  marginBottom: "15px",
                  display: "flex",
                      flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "5px",
                        width: "100%",
                  }}
                >
                  {renderFormLabel("Password")}
                  <div style={{ flex: 1, position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formValues.password}
                      onChange={handleInputChange}
                      placeholder="Password"
                      style={{
                        width: "100%",
                        padding: "8px",
                        borderRadius: "5px",
                        border: `1px solid ${
                          formErrors.password ? "red" : "#ccc"
                        }`,
                        boxSizing: "border-box",
                      }}
                    />
                    <div
                      onClick={togglePasswordVisibility}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#666",
                      }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </div>
                    
                    {/* Password validation tooltip */}
                    {formValues.password && !allPasswordConditionsMet && showPasswordTooltip && (
                      <div style={{
                        ...passwordTooltipStyle,
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          left: '20px',
                          top: '-8px',
                          width: '0',
                          height: '0',
                          borderLeft: '8px solid transparent',
                          borderRight: '8px solid transparent',
                          borderBottom: '8px solid #2c2c2c'
                        }
                      }}>
                        <div style={{ 
                          borderBottom: '1px solid rgba(255,255,255,0.1)', 
                          paddingBottom: '8px',
                          marginBottom: '8px',
                          fontWeight: 'bold'
                        }}>
                          Use Strong Password
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          <div style={{ 
                            color: passwordValidation.length ? "#4CAF50" : "#fff",
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}>
                            <span style={{ fontSize: '16px' }}>{passwordValidation.length ? "✓" : "○"}</span>
                            At least 8 characters
                          </div>
                          <div style={{ 
                            color: passwordValidation.uppercase ? "#4CAF50" : "#fff",
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}>
                            <span style={{ fontSize: '16px' }}>{passwordValidation.uppercase ? "✓" : "○"}</span>
                            One uppercase letter
                          </div>
                          <div style={{ 
                            color: passwordValidation.lowercase ? "#4CAF50" : "#fff",
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}>
                            <span style={{ fontSize: '16px' }}>{passwordValidation.lowercase ? "✓" : "○"}</span>
                            One lowercase letter
                          </div>
                          <div style={{ 
                            color: passwordValidation.number ? "#4CAF50" : "#fff",
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}>
                            <span style={{ fontSize: '16px' }}>{passwordValidation.number ? "✓" : "○"}</span>
                            One number
                          </div>
                          <div style={{ 
                            color: passwordValidation.specialChar ? "#4CAF50" : "#fff",
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}>
                            <span style={{ fontSize: '16px' }}>{passwordValidation.specialChar ? "✓" : "○"}</span>
                            One special character (@$!%*?&)
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {formErrors.password && (
                  <small
                    style={{
                      color: "red",
                      display: "block",
                      marginLeft: "160px",
                    }}
                  >
                    {formErrors.password}
                  </small>
                )}
              </div>

              {/* Update terms and conditions styling for better mobile display */}
              <div 
                style={{ 
                  textAlign: "center",
                  marginBottom: "5px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "0 15px",
                  width: "100%"
                }}
              >
                <div style={{ 
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  maxWidth: "100%",
                  justifyContent: "center"
                }}>
                  <input
                    type="checkbox"
                    id="terms"
                    checked={agreedToTerms}
                    onChange={(e) => setAgreedToTerms(e.target.checked)}
                    style={{ marginTop: "4px" }}
                  />
                  <div 
                    style={{ 
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "2px"
                    }}
                  >
                    <label 
                      htmlFor="terms" 
                      style={{ 
                        color: "#666",
                        textAlign: "center",
                        lineHeight: "1.4",
                        margin: 0
                      }}
                    >
                      I agree to the{" "}
                      <a
                        href={TermsAndConditionsPDF}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                          cursor: "pointer"
                        }}
                      >
                        Terms and Conditions
                      </a>
                    </label>
                    <label 
                      htmlFor="terms" 
                      style={{ 
                        color: "#666",
                        textAlign: "center",
                        lineHeight: "1.4",
                        margin: 0
                      }}
                    >
                      of this website.
                    </label>
                  </div>
                </div>
                {formErrors.terms && (
                  <p style={{ 
                    color: "red", 
                    fontSize: "12px", 
                    marginTop: "5px",
                    textAlign: "center",
                    width: "100%" 
                  }}>
                    {formErrors.terms}
                  </p>
                )}
              </div>

              {/* Buttons section without border */}
              <div style={{ marginTop: "5px", paddingTop: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  {!invitationParams.isValid && !isStandalonePage && (
                    <button
                      type="button"
                      onClick={() => setFormPage(1)}
                      style={{
                        width: "48%",
                        padding: "10px",
                        backgroundColor: "#6c757d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      Back
                    </button>
                  )}
                  <button
                    type="submit"
                    style={{
                      width: invitationParams.isValid || isStandalonePage ? "100%" : "48%",
                      padding: "10px",
                      backgroundColor: "green",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
                </form>

                {/* Add Sign In link */}
            <div
              style={{
                textAlign: "center",
                    marginTop: "20px",
                    borderTop: "1px solid #ddd",
                    paddingTop: "20px",
              }}
            >
                  <span>Have an account? </span>
              <span
                onClick={() => setShowSignIn(true)}
                style={{
                  color: "#007bff",
                  cursor: "pointer",
                      textDecoration: "underline",
                }}
              >
                Sign In
              </span>
            </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SignUpForm;

// Add CSS for spinner animation
const style = document.createElement("style");
style.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);

// Add this CSS at the bottom of the file, after the spinner animation
const emailStyles = document.createElement("style");
emailStyles.textContent = `
  @media screen and (max-width: 480px) {
    .email-verification-container {
      flex-direction: column !important;
    }
    
    .verify-email-button {
      width: 100% !important;
      margin-top: 10px;
    }

    .otp-verification-container {
      flex-direction: column !important;
    }

    .verify-otp-button {
      width: 100% !important;
      margin-top: 10px;
    }
  }
`;
document.head.appendChild(emailStyles);
